"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_websocket_1 = require("./lib/use-websocket");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return use_websocket_1.useWebSocket; } });
var use_socket_io_1 = require("./lib/use-socket-io");
Object.defineProperty(exports, "useSocketIO", { enumerable: true, get: function () { return use_socket_io_1.useSocketIO; } });
var constants_1 = require("./lib/constants");
Object.defineProperty(exports, "ReadyState", { enumerable: true, get: function () { return constants_1.ReadyState; } });
//# sourceMappingURL=index.js.map